import { moduleProviderFactory } from 'core/providers';
import { CorporateEdit, CorporateList, CorporatePreview } from 'application/corporate/pages';

(function () {
    moduleProviderFactory.application.register({
        routes: [
            {
                name: 'master.app.main.corporate',
                pattern: '/corporates',
                children: [
                    {
                        name: 'master.app.main.corporate.list',
                        pattern: '',
                        tabTitle:'CORPORATE.LIST.TITLE',
                        component: CorporateList,
                        data: {
                            title: 'CORPORATE.LIST.TITLE'
                        }
                    },
                    {
                        name: 'master.app.main.corporate.create',
                        pattern: '/create',
                        component: CorporateEdit,
                        authorization: 'portalSection.create',
                        data: {
                            title: 'CORPORATE.CREATE.TITLE',
                            nikoTitle: 'CORPORATE.CREATE.NIKO_TITLE'
                        },
                    },
                    {
                        name: 'master.app.main.corporate.preview',
                        pattern: '/preview/:id',
                        tabTitle:'Corporate Preview',
                        component: CorporatePreview,
                        data: {
                            title: 'CORPORATE.EDIT.TITLE'
                        },
                    },
                    {
                        name: 'master.app.main.corporate.edit',
                        pattern: '/edit/:id',
                        tabTitle:'Edit Corporate',
                        component: CorporateEdit,
                        data: {
                            title: 'CORPORATE.EDIT.TITLE'
                        },
                    }                 
                ]
            }
        ],
        menu : [
            {
                title: 'MENU.FACILITIES',
                order: 4,
                icon: 'facilities',
                subMenu: [
                    {
                        title: 'MENU.CORPORATES',
                        route: 'master.app.main.corporate.list',
                        order: 3,
                    }                    
                ]
            }
        ]
    });
})();
